import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useColorModeValue } from '@chakra-ui/react';
import AccountSettings from './AccountSettings';
import SetAvailability from './AvailabilitySettings';
import Notifications from './Notifications';
import MediaComponent from './Media';

const Content = ({ userData, updateUser, isEditable }) => {
  let tabs;
  if (!isEditable) {
    tabs = ['Media'];
  } else {
    tabs = ['Account Settings', 'Media', 'Availability', 'Notifications'];
  }


  const bgColor = useColorModeValue('white', 'black');
  const headingColor = useColorModeValue('black', 'white');
  const borderColor = useColorModeValue('gray.200', 'white');

  // Function to handle adding media
  const handleAddMedia = (newMedia) => {
    const updatedUserData = {
      ...userData,
      photos: [...userData.photos, newMedia.photo],
      videos: [...userData.videos, newMedia.video],
    };
    updateUser(updatedUserData);  // Call updateUser to update the user's media
  };
  return (
    <Box
      as="main"
      bg={bgColor}
      flex={3}
      d="flex"
      flexDir="column"
      justifyContent="space-between"
      pt={5}
      rounded="md"
      borderWidth={1}

      style={{ transform: 'translateY(-100px)' }}
    >
      <Tabs borderColor={borderColor}>
        <TabList px={5}>
          {tabs.map((tab) => (
            <Tab
              key={tab}
              mx={3}
              px={0}
              py={3}
              fontWeight="semibold"
              borderBottomWidth={1}
              _active={{ bg: 'transparent' }}
              _selected={{ color: headingColor, borderColor: 'blue' }}
            >
              {tab}
            </Tab>
          ))}
        </TabList>

        <TabPanels px={3} mt={5}>
        {isEditable && (
          <TabPanel>
            <AccountSettings 
            userData={userData} 
            updateUser={updateUser} 
            isEditable={isEditable} 
            />
          </TabPanel>
          )}
          <TabPanel>
            <Text fontSize="2xl" mb={4}>Portfolio</Text>
            <MediaComponent 
              photos={userData.photos || []} 
              videos={userData.videos || []} 
              handleAddMedia={handleAddMedia}  // Passing the handleAddMedia function
              userId={userData.id}
              isEditable={isEditable}
            />

          </TabPanel>
          <TabPanel>
            <SetAvailability isEditable={isEditable} photographerId={userData.id} />
          </TabPanel>
          <TabPanel>
            <Notifications isEditable={isEditable} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Content;
